export default class StringOperations {
  static capitalizeFirst(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : null;
  }

  static capitalizeAll(string) {
    return string
      ? string
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      : null;
  }

  static stringToBoolean(value) {
    if (value === 'true') {
      return true;
    } else if (value === 'false') {
      return false;
    }
  }
}
